
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[id]/reset-password",
      function () {
        return require("private-next-pages/[id]/reset-password.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[id]/reset-password"])
      });
    }
  